import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ClientParentDetailsHttpService } from '@client-parents/services/client-parent-details-http.service';
import * as clientParentDetailsActions from '@client-parents/actions/client-parent-details.actions';

@Injectable()
export class ClientParentDetailsEffects {

  constructor(
    private readonly actions: Actions,
    private readonly clientParentDetailsHttpService: ClientParentDetailsHttpService
  ) { }

  
  get: Observable<Action> = createEffect(() => this.actions.pipe(
    ofType<clientParentDetailsActions.Get>(clientParentDetailsActions.GET),
    switchMap((action) => {
      return this.clientParentDetailsHttpService.getDetails(action.payload).pipe(
        map((details) => new clientParentDetailsActions.GetComplete(details))
      );
    })));

}
